const getDOMElm = (font, size, sizeUnit) => {
    let div = document.querySelector('#jalla');
    if (!div) {
        //div = document.createElement('textarea');
        div = document.createElement('div');
        div.id = 'jalla';
    }

    div.style.fontFamily = font;
    div.style.fontSize = size + sizeUnit;
    div.style.backgroundColor = 'red';
    div.style.whiteSpace = 'pre-wrap';
    div.style.display = 'inline-block';
    div.style.position = 'absolute';
    //div.style.opacity = '0';
    div.style.lineHeight = 'normal';
    div.style.overflowWrap = 'normal';
    div.style.overflowX = 'hidden';
    div.style.overflowY = 'hidden';
    div.style.height = 0;
    div.style.padding = 0;
    div.style.border = 'none';
    return div;
}

export const getRotatedBoundingRect = (position, size, angle, rotateOrigin) => {
    const theAngle = (angle *  Math.PI / 180)

    const {x, y} = position;
    const {width: w, height: h} = size;

    const {x0, y0} = {
        x0: x + rotateOrigin.x,
        y0: y + rotateOrigin.y,
    }

    const theta = theAngle;
    const y1 = y0-(x-x0)*Math.sin(theta)+(y-y0)*Math.cos(theta);
    const y2 = y0-(x+w-x0)*Math.sin(theta)+(y-y0)*Math.cos(theta)
    const y3 = y0-(x-x0)*Math.sin(theta)+(y+h-y0)*Math.cos(theta)
    const y4 = y0-(x+w-x0)*Math.sin(theta)+(y+h-y0)*Math.cos(theta)
    const x1 = x0+(x-x0)*Math.cos(theta)+(y-y0)*Math.sin(theta);
    const x2 = x0+(x+w-x0)*Math.cos(theta)+(y-y0)*Math.sin(theta);
    const x3 = x0+(x-x0)*Math.cos(theta)+(y+h-y0)*Math.sin(theta);
    const x4 = x0+(x+w-x0)*Math.cos(theta)+(y+h-y0)*Math.sin(theta);

    const minY = Math.min(y1, y2, y3, y4);
    const minX = Math.min(x1, x2, x3, x4);
    const maxY = Math.max(y1, y2, y3, y4);
    const maxX = Math.max(x1, x2, x3, x4);

    console.log('Rotation Y', y-w, y1, y2, y3, y4);
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}

export const getTextLines = (font, text, size, sizeUnit, width) => {
    const div = getDOMElm(font, size, sizeUnit);
    div.style.width = width + 'px';
    div.style.whiteSpace = 'pre';

    document.body.appendChild(div);

    const lines = [];
    const textAreaLines = text.split(/\r*\n/g);
    let currentLine = "";

    div.innerHTML = '<br/>';
    const lineHeight = div.scrollHeight;
    div.innerHTML = '';
    for (const line of textAreaLines) {
        const words = line.split(/\s/g);
        for (const word of words) {
            div.innerHTML += word + " ";
            console.log('Lines Checking word', word, div.scrollWidth, width, div.innerHTML)
            if (div.scrollWidth > width) {
                // If there is room without without the last space, remove it:
                div.innerHTML = div.innerHTML.substr(0, div.innerHTML.length - 1)
                console.log('The inner html', JSON.stringify(div.innerHTML), div.scrollWidth, width);
                if (div.scrollWidth <= width) {
                    console.log('There is room without the space!')
                    lines.push(div.innerHTML);
                    currentLine = "";
                    div.innerHTML = "";
                }
                else {
                    // It's still too long!
                    lines.push(currentLine.trim());
                    currentLine = word + " ";
                    div.innerHTML = word + " ";
                }
            }
            else {
                currentLine += word + " ";
            }
        }
        if (currentLine) {
            lines.push(currentLine.substr(0, currentLine.length-1).trim());
            div.innerHTML = "";
            currentLine = "";
        }
    }
    document.body.removeChild(div);
    return lines;
}

export const getTextDimensions = (font, text, size, sizeUnit, width) => {
    const div = getDOMElm(font, size, sizeUnit)

    div.style.width = width + 'px';
    div.style.whiteSpace = 'pre-wrap';

    // When we hit enter, the text height is wrong if we got empty line:
    const formatedText = text.split(/\n/g)
        .map(line => line || "dummytext")
        .join("\n")

    console.log('Formated text', JSON.stringify(formatedText));

    div.innerHTML = formatedText;

    console.log('Dim', div, text)

    document.body.appendChild(div);
    const dim = {width: div.scrollWidth, height: div.scrollHeight};
    div.style.height = div.scrollHeight + 'px';
    document.body.removeChild(div);
    return dim;
}